// extracted by mini-css-extract-plugin
module.exports = {"fileRow":"Home2FilesCard_fileRow__bQGZ_","fileName":"Home2FilesCard_fileName__tkeTZ"};